/** @format */

import { notificationConstants } from '../notifications/notifications';
import { reducerDebug } from '../../core/debug';

export type pricelistsReducersType = {
    type?: string;
    collections?: any;
    list?: any;
    listOnDetail?: any;
    item?: any;
    processSuccess?: boolean;
    success?: boolean;
    data?: any;
    deletedSuccess?: boolean;
    message?: string;
};

export const pricelistsConstants = {
    LIST: 'pricelists_list',
    ITEM: 'pricelists_item',
    EDIT: 'pricelists_edit',
    DELETE: 'pricelists_delete',
    MANAGE: 'pricelists_manage',
    ADD: 'pricelists_add',
};

export const pricelistSchemaElementConstants = {
    LIST: 'pricelist_schema_element_list',
    LIST_ON_DETAIL: 'pricelist_schema_element_list_on_detail',
    ITEM: 'pricelist_schema_element_item',
    EDIT: 'pricelist_schema_element_edit',
    DELETE: 'pricelist_schema_element_delete',
    MANAGE: 'pricelist_schema_element_manage',
    ADD: 'pricelist_schema_element_add',
};

export const pricelistSchemaConnectorConstants = {
    LIST: 'pricelist_schema_connector_list',
    ITEM: 'pricelist_schema_connector_item',
    EDIT: 'pricelist_schema_connector_edit',
    DELETE: 'pricelist_schema_connector_delete',
    MANAGE: 'pricelist_schema_connector_manage',
    ADD: 'pricelist_schema_connector_add',
};

export const pricelistSchemaElementFractionConstants = {
    LIST: 'pricelist_schema_element_fraction_list',
    ITEM: 'pricelist_schema_element_fraction_item',
    EDIT: 'pricelist_schema_element_fraction_edit',
    DELETE: 'pricelist_schema_element_fraction_delete',
    MANAGE: 'pricelist_schema_element_fraction_manage',
    ADD: 'pricelist_schema_element_fraction_add',
};

export const pricelistSchemaElementPrefixConstants = {
    LIST: 'pricelist_schema_element_prefix_list',
    ITEM: 'pricelist_schema_element_prefix_item',
    EDIT: 'pricelist_schema_element_prefix_edit',
    DELETE: 'pricelist_schema_element_prefix_delete',
    MANAGE: 'pricelist_schema_element_prefix_manage',
    ADD: 'pricelist_schema_element_prefix_add',
};

export const pricelistSchemaConstants = {
    LIST: 'pricelist_schema_list',
    ITEM: 'pricelist_schema_item',
    EDIT: 'pricelist_schema_edit',
    DELETE: 'pricelist_schema_delete',
    MANAGE: 'pricelist_schema_manage',
    ADD: 'pricelist_schema_add',
};

export function pricelistsReducers(state = {}, action: pricelistsReducersType): object {
    reducerDebug('Pricelists reducer: ' + action.type);
    switch (action.type) {
        case pricelistsConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case pricelistsConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case pricelistsConstants.ADD:
        case pricelistsConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case pricelistsConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
            };
    }
}

export function pricelistsSchemaElementFractionReducers(state = {}, action: pricelistsReducersType): object {
    reducerDebug('Pricelists Schema Element Fraction reducer: ' + action.type);
    switch (action.type) {
        case pricelistSchemaElementFractionConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case pricelistSchemaElementFractionConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case pricelistSchemaElementFractionConstants.ADD:
        case pricelistSchemaElementFractionConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case pricelistSchemaElementFractionConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
            };
    }
}

export function pricelistsSchemaElementPrefixReducers(state = {}, action: pricelistsReducersType): object {
    reducerDebug('Pricelists Schema Element Prefix reducer: ' + action.type);
    switch (action.type) {
        case pricelistSchemaElementPrefixConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case pricelistSchemaElementPrefixConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case pricelistSchemaElementPrefixConstants.ADD:
        case pricelistSchemaElementPrefixConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case pricelistSchemaElementPrefixConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
            };
    }
}

export function pricelistSchemasReducers(state = {}, action: pricelistsReducersType): object {
    reducerDebug('Pricelist Schemas reducer: ' + action.type);
    switch (action.type) {
        case pricelistSchemaConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case pricelistSchemaConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case pricelistSchemaConstants.ADD:
        case pricelistSchemaConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case pricelistSchemaConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
            };
    }
}

export function pricelistSchemaElementsReducers(state = {}, action: pricelistsReducersType): object {
    reducerDebug('pricelist Schema Elements reducer: ' + action.type);
    switch (action.type) {
        case pricelistSchemaElementConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case pricelistSchemaElementConstants.LIST_ON_DETAIL:
            return {
                ...state,
                type: action.type,
                listOnDetail: action.collections,
            };
        case pricelistSchemaElementConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case pricelistSchemaElementConstants.ADD:
        case pricelistSchemaElementConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case pricelistSchemaElementConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
            };
    }
}

export function pricelistSchemaConnectorReducers(state = {}, action: pricelistsReducersType): object {
    reducerDebug('pricelist Schema Connector reducer: ' + action.type);
    switch (action.type) {
        case pricelistSchemaConnectorConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case pricelistSchemaConnectorConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case pricelistSchemaConnectorConstants.ADD:
        case pricelistSchemaConnectorConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case pricelistSchemaConnectorConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
            };
    }
}
